import CancelOutlined from "@mui/icons-material/CancelOutlined";
import MailOutlined from "@mui/icons-material/MailOutlined";
import RemoveRedEye from "@mui/icons-material/RemoveRedEye";
import Restore from "@mui/icons-material/Restore";
import Save from "@mui/icons-material/Save";
import SmsOutlined from "@mui/icons-material/SmsOutlined";
import UploadFile from "@mui/icons-material/UploadFile";
import Chip from "@mui/material/Chip";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import React from "react";
import styled, { css } from "styled-components";
import { FileUploadView } from "./FileUploadView";
import { HXAutocomplete } from "./HXAutocomplete";
import { HXButton } from "./HXButton";
import { Text } from "./HXDesktopPage.styles";
import { HXCheckbox, HXTextField } from "./base.styles";
import { FlexColumnDiv } from "./common.styles";
const textFieldWidth = 360;
export const Parent = styled(FlexColumnDiv) `
    padding: 24px 0;
    align-items: flex-start;
    gap: 40px;
    flex: 1 0 0;
    align-self: stretch;
`;
export const MailOutlinedIcon = styled(MailOutlined) `
    width: 24px;
    height: 24px;
    color: ${colors.black_lighter};
`;
export const SmsOutlinedIcon = styled(SmsOutlined) `
    width: 24px;
    height: 24px;
    color: ${colors.black_lighter};
`;
export const CheckboxBold = styled(HXCheckbox) `
    ${(props) => props.error &&
    css `
            .MuiSvgIcon-root {
                color: ${colors.tulip_main};
            }

            .MuiFormControlLabel-label {
                color: ${colors.tulip_main};
            }
        `}

    .MuiFormControlLabel-label {
        font-weight: ${fontWeights.BOLD};
    }
`;
export const CheckboxText = styled(Text) `
    padding-left: 42px;
`;
export const AutocompleteNumber = styled((HXAutocomplete)) `
    width: ${textFieldWidth}px;
`;
export const AutocompleteContactMethod = styled((HXAutocomplete)) `
    width: ${textFieldWidth}px;
`;
export const TextField = styled(HXTextField) `
    width: ${textFieldWidth}px;
`;
export const WideTextField = styled(HXTextField) `
    width: 658px;
`;
export const UploadButton = styled(HXButton).attrs({
    secondary: true,
    startIcon: React.createElement(UploadFile),
    component: "label",
}) `
    min-width: 100px;
`;
export const SaveButton = styled(HXButton).attrs({
    startIcon: React.createElement(Save),
}) `
    min-width: 85px;
`;
export const RestoreAllDefaultsButton = styled(HXButton).attrs({
    secondary: true,
    startIcon: React.createElement(Restore),
    children: "Restore all defaults",
}) `
    min-width: 120px;
`;
export const PreviewButton = styled(HXButton).attrs({
    text: true,
    startIcon: React.createElement(RemoveRedEye),
}) `
    min-width: 120px;
`;
export const ExcludeButton = styled(HXButton).attrs({
    secondary: true,
    startIcon: React.createElement(CancelOutlined),
}) ``;
export const OnboardingCardContainer = styled(FlexColumnDiv) `
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;

    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    background: ${colors.white_main};
`;
export const PatientDecisionRequiredChip = styled(Chip).attrs({ variant: "outlined", label: "Patient decision required" }) ``;
export const WarningBanner = styled(Text) `
    padding: 16px;
    border-radius: var(--borderRadius, 4px);
    border: 1px solid ${colors.accents_sun};
    background: ${colors.accents_sunset_background};
`;
export const HIPPAAuthUploadView = styled(FileUploadView) `
    height: 160px;
    align-self: stretch;
`;
export const VideoUploadView = styled(FileUploadView) `
    align-self: stretch;
`;
